import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SimpleImage, Typography } from "@parkschannel/ui";
import React from "react";
import { TvStatus } from "../../../Tv";
export const AboutUsCover = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "relative bg-neutral-200 w-full h-[568px] rounded-2xl overflow-hidden lg:h-[635px]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute top-0 left-0 w-full h-full",
                children: [
                    /*#__PURE__*/ _jsx(SimpleImage, {
                        src: "/media/flower-photography.jpg",
                        fill: true,
                        className: "object-cover",
                        alt: "About us page cover"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/20 to-black/50"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "px-4 pt-8 pb-10 w-full h-full relative bg-transparent flex flex-col justify-between md:px-[30px] md:py-10 lg:px-[116px] lg:pt-[80px] lg:pb-[100px]",
                children: [
                    /*#__PURE__*/ _jsxs("section", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                component: "h5",
                                variant: "h6",
                                className: "uppercase text-white mb-4",
                                children: "the parks channel"
                            }),
                            /*#__PURE__*/ _jsx(TvStatus, {
                                text: "About us",
                                color: "white",
                                className: "gap-1 !py-1 !px-3",
                                icon: /*#__PURE__*/ _jsx("img", {
                                    src: "/TPC-small-logo.png",
                                    alt: "The Parks Channel logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("article", {
                        className: "max-w-[521px] lg:max-w-[775px]",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h1",
                                className: "line-clamp-3 !text-[28px] text-white mb-2 lg:!text-[48px] lg:mb-3",
                                children: "We are the Parks Channel"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "bodyXL",
                                className: "line-clamp-3 text-white",
                                children: "We believe in the power of places to inspire, entertain and inform"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
